module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp123_6005.89872702.png";